import { useEffect, useState } from "react";
import { GoCheckCircle } from "react-icons/go";
import { PiSpotifyLogoLight } from "react-icons/pi";

const PlaylistComp = ({item, isSelected, onSelect}) => {
  const [isActive, setActive] = useState(false);
  const [playlistType, setPlaylistType] = useState("Apple");

  const link = item.external_urls.spotify;
  const image = item.images[0].url;

  useEffect(() => {
    if (link.includes("spotify")) {
      setPlaylistType("Spotify");
    }
  }, [link]);

  const selectedPlaylist = () => { 
   onSelect(item.id);
   console.log(item.id)
  };

  return (
    <div onClick={selectedPlaylist} className="mb-4 p-4 bg-[#0a0a0a] rounded-md">
      <div className="flex items-center justify-between">
        {playlistType === "Spotify" ? (
          <>
            <div className="flex items-center justify-center bg-[#0a0a0a] gap-3">
              <img
                src={image}
                className="w-24 h-24 rounded-full"
                alt="Playlist Cover"
              />
               <div className=" flex flex-col items-start">
              <h5 className="text-lg font-medium">{item.name}</h5>
              <p className="text-sm font-light">By {item.owner.display_name}</p>
              <p className="text-sm font-medium">{item.tracks.total} songs</p>
            </div>
            </div>
           
          </>
        ) : (
          <div className="flex items-center justify-center">
            <img
              src={image}
              className="w-24 h-24 rounded-full"
              alt="Playlist Cover"
            />
          </div>
        )}

       

        <div className="flex items-center space-x-4">
          <div className="p-4">
            {
              !isSelected? 
              playlistType === "Spotify" ? (
                <PiSpotifyLogoLight
                  color="green"
                  className="w-20 h-20 self-center"
                />
              ) : (
                <PiSpotifyLogoLight
                  color="green"
                  className="w-20 h-20 self-center"
                />
              ):
              (
                <div className="p-4">
                   <GoCheckCircle color="white" className="w-10 h-10" />
                </div>
              )
            }
            
          </div>

         
        </div>
      </div>
    </div>
  );
};

export default PlaylistComp;
